// extracted by mini-css-extract-plugin
module.exports = {"desktop_facet_container":"styles_desktop_facet_container__Hx_7W"};